import { render, staticRenderFns } from "./ProgrammesDonut.vue?vue&type=template&id=e90109f0&"
import script from "./ProgrammesDonut.vue?vue&type=script&lang=js&"
export * from "./ProgrammesDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports